import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { DailyPartialRegularRestBlock } from '../blocks/DailyPartialRegularRestBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const DailyPartialRegularRestsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { dailyPartialRegularRests } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {dailyPartialRegularRests.map((item, index) => (
        <DailyPartialRegularRestBlock
          key={index}
          dailyPartialRegularRest={item}
          index={index}
        />
      ))}
    </LayerWrapper>
  )
}

export default DailyPartialRegularRestsLayer
